export enum PushTypeDto {
  CATCHPHRASE,
  PROFILE,
  GENERIC,
}
